import React from 'react';
import Head from 'next/head';
import Terms from 'app/features/settings/Terms';

export default function TermsAndConditionsPage() {
  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Review Pandaist's Terms and Conditions to understand the rules, guidelines, and legal agreement governing the use of our platform. Learn about user responsibilities, content policies, and our service commitments."
        />
        <title>Terms and Conditions | Pandaist</title>
        <link rel="canonical" href="https://pandaist.com/terms" />
        <meta
          name="twitter:description"
          content="Review Pandaist's Terms and Conditions to understand the rules, guidelines, and legal agreement governing the use of our platform. Learn about user responsibilities, content policies, and our service commitments."
        />
        <meta property="og:locale" content="en_US" />
        <meta
          property="og:site_name"
          content="Pandaist | Learn Chinese by Reading"
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Terms and Conditions | Pandaist" />
        <meta
          property="og:description"
          content="Review Pandaist's Terms and Conditions to understand the rules, guidelines, and legal agreement governing the use of our platform. Learn about user responsibilities, content policies, and our service commitments."
        />
        <meta property="og:url" content="https://pandaist.com/terms" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Terms and Conditions | Pandaist" />
        <meta
          property="og:image"
          content={'https://cdn.pandaist.com/main/images/bigpanda.png'}
        />
        <meta
          name="twitter:image"
          content={'https://cdn.pandaist.com/main/images/bigpanda.png'}
        />
      </Head>
      <Terms />
    </>
  );
}
